import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=1906b769"
import script from "./SettingsPopup.vue?vue&type=script&lang=ts"
export * from "./SettingsPopup.vue?vue&type=script&lang=ts"
import style0 from "./SettingsPopup.vue?vue&type=style&index=0&id=1906b769&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports